<template>
  <div>
    <h1>Tabela de ocorrências PROCEDA</h1>
    <div>
      <b-table hover :items="items" :fields="fields">
        <!-- <template v-slot:cell(id)="data">
        <router-link :to="'/usuario/edit/' + data.value">{{ data.value }}</router-link>
        </template>-->
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "List",
  data: function () {
    return {
      fields: [
        // {
        //   key: "id",
        //   sortable: true
        // },
        {
          key: "codigo",
          sortable: true,
        },
        {
          key: "descricao",
          sortable: true,
        },
      ],
      items: [],
    };
  },
  created: function () {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.$apiNoAuthenticated
        .get("/tabelaOcorrenciaProceda")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },
};
</script>

